import { render, staticRenderFns } from "./SearchPage.vue?vue&type=template&id=66c0e074&scoped=true&"
import script from "./SearchPage.vue?vue&type=script&lang=js&"
export * from "./SearchPage.vue?vue&type=script&lang=js&"
import style0 from "./SearchPage.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SearchPage.vue?vue&type=style&index=1&id=66c0e074&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c0e074",
  null
  
)

export default component.exports